/**
 * Lo que queda de las mutaciones de GENTE de la academia (F3-D) tras el plan
 * 06 · E4: **nada que escriba**.
 *
 * Aquí vivían `createStudentProfileMutation`, `updateStudentProfileMutation`,
 * `updateStudentNotesMutation`, `createTeacherProfileMutation` y
 * `updateTeacherProfileMutation`: inserciones y updates sobre el SQLite local
 * que la cola de sync subía al write-path. Con las filas de TERCEROS fuera de
 * los streams (`org_admin_scope`, `campus_admin_scope`, `academy_org`) el
 * `UPDATE … WHERE id = ?` no encontraba fila y la edición del staff se perdía
 * **en silencio**: sin error, sin op, sin rastro. Peor que un fallo.
 *
 * La escritura vive ahora en el servidor, que es donde ya vivía el permiso:
 *   · `PUT /api/academy/:orgId/students/:userId`
 *   · `PUT /api/academy/:orgId/teachers/:userId`
 *   · `POST|DELETE /api/org/{add,remove}Guardian` (ya era así)
 *
 * El patch REST es DISPERSO igual que lo era el `set()` de Drizzle: lo que no
 * se manda no se toca. Esa equivalencia es lo que permite que las pantallas no
 * cambien de forma al cambiar de transporte.
 *
 * Sobrevive `slugifyPublicSlug`, que no escribe nada: es una transformación
 * pura de texto que la interfaz aplica ANTES de mandar el patch.
 */

/** Slugify básico para `public_slug` (minúsculas, guiones, sin acentos). */
export function slugifyPublicSlug(input: string): string {
  return input
    .normalize("NFD")
    .replaceAll(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replaceAll(/[^a-z0-9]+/g, "-")
    .replaceAll(/(^-+)|(-+$)/g, "")
    .slice(0, 64);
}
